import { render, staticRenderFns } from "./ServiceBranchAssignmentSection.vue?vue&type=template&id=b21e8c84&lang=pug&"
import script from "./ServiceBranchAssignmentSection.vue?vue&type=script&lang=js&"
export * from "./ServiceBranchAssignmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports